/* istanbul ignore file */
import { EmployeeOfficeField } from 'domain/shared/employee';

const VacancyOfficeField = (props: any) => {
  return <EmployeeOfficeField {...props} />;
};

export default VacancyOfficeField;
